<template>
  <div>
    <slot />

    <slot
      v-if="mediaLoaded"
      name="ctaBannerTop"
    />

    <XEmbedBase
      :srcdoc="thumbnail"
      class="px-5"
      :class="$style.embed"
      @loaded="onLoad"
    >
      <div :class="$style.spinner">
        <XMediaSpinner />
      </div>
    </XEmbedBase>

    <slot
      v-if="mediaLoaded"
      name="ctaBannerBottom"
    />

    <slot
      v-if="mediaLoaded"
      name="footer"
    />
  </div>
</template>

<script>
import Mixin from './mixin'

export default {
  mixins: [Mixin],

  props: {
    thumbnail: {
      type: String,
      default: ''
    }
  },

  methods: {
    onLoad () {
      this.emitMediaLoaded()
    }
  }
}
</script>

<style lang="scss" module>
.embed {
  min-height: 100px;
}

.spinner {
  @apply relative;

  min-height: 100px;

  & > div {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
